import {Routes} from "@angular/router";
import {LayoutComponent} from "../ds/component/layout/layout.component";
import {authGuard} from "../core/auth/auth.guard";
import {ReferPage} from "./page/refer-page/refer.page";
export function CsSubRoutes() : Routes {

  /**
   *
   * path:
   * Prefix of the module will always be added to the path name
   *
   *      Example
   *      path: "addresses" => route path "ad/addresses" !
   * ------------------------------------------------------------------
   *
   * component:
   * Added components need to be from type "Page"!
   * ------------------------------------------------------------------
   *
   */
  const routes: Routes = [

    {path: 'cs', component: LayoutComponent, canActivate: [authGuard],

      children: [
        { path: 'refer', component: ReferPage  },
        ]
    }

  ];

  return routes;

}
